<template>
  <v-sheet elevation="4" class="sticky top-0 z-[1]">
    <div
      class="bg-breadcrumb"
      :class="{
        'auto-padding': padding,
      }"
    >
      <div class="flex">
        <router-link v-for="(el, i) in elements" :key="i" :to="el.to" v-slot="{ href, navigate }">
          <a
            :href="href"
            @click="navigate"
            class="max-w-xs"
            :class="{
              'pointer-events-none': el.last,
            }"
          >
            <div
              class="px-6 py-2 flex align-center breadcrumb-element transition-all duration-300 hover:bg-breadcrumb-hover cursor-pointer"
              :class="{
                'bg-breadcrumb-hover': $route.name == el.name,
              }"
            >
              <span class="text-white flex items-center">
                <span class="flex items-center" v-if="el.icon">
                  <v-icon color="white" x-small left>{{ el.icon }}</v-icon>
                </span>
                <span class="truncate"> {{ el.text }}</span>
                <span class="flex items-center" v-if="!el.last"
                  ><v-icon color="white" x-small right>fas fa-chevron-right</v-icon></span
                ></span
              >
            </div>
          </a>
        </router-link>
      </div>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: {
    elements: {
      type: Array,
      default() {
        return [];
      },
    },
    padding: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb-element {
  box-shadow: 5px 0px 5px -5px rgba(0, 0, 0, 0.25);
}
.element-hover {
  background-color: red;
}
</style>